"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenShiftVersionModal = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_core_1 = require("@patternfly/react-core");
const OpenShiftSelectWithSearch_1 = require("./OpenShiftSelectWithSearch");
const formik_1 = require("formik");
require("./OpenShiftVersionModal.css");
const OpenShiftVersionModal = ({ allVersions, setOpenshiftVersionModalOpen, getHelperText, }) => {
    const { setFieldValue } = (0, formik_1.useFormikContext)();
    const onClose = () => setOpenshiftVersionModalOpen(false);
    const [customOpenshiftSelect, setCustomOpenshiftSelect] = (0, react_1.useState)(); // Cambiar el tipo según lo que esperes aquí
    const handleSelect = () => {
        if (customOpenshiftSelect) {
            setFieldValue('customOpenshiftSelect', customOpenshiftSelect);
        }
        onClose();
    };
    return (react_1.default.createElement(react_core_1.Modal, { title: "Available OpenShift Versions", id: "available-openshift-versions-modal", isOpen: true, actions: [
            react_1.default.createElement(react_core_1.Button, { key: "select-custom-ocp", variant: react_core_1.ButtonVariant.primary, onClick: handleSelect }, "Select"),
            react_1.default.createElement(react_core_1.Button, { key: "close-custom-ocp", variant: react_core_1.ButtonVariant.link, onClick: onClose }, "Cancel"),
        ], onClose: onClose, variant: react_core_1.ModalVariant.small },
        react_1.default.createElement(react_core_1.FormGroup, { id: `form-control__customOpenshiftSelect`, fieldId: 'customOpenshiftSelect', label: 'OpenShift version', isRequired: true },
            react_1.default.createElement(OpenShiftSelectWithSearch_1.OpenShiftSelectWithSearch, { versions: allVersions, getHelperText: getHelperText, setCustomOpenshiftSelect: setCustomOpenshiftSelect }))));
};
exports.OpenShiftVersionModal = OpenShiftVersionModal;
//# sourceMappingURL=OpenShiftVersionModal.js.map